<template>
  <GestionAnalisis />
</template>
<script>
import GestionAnalisis from "./components/GestionAnalisis";
export default {
  name: "AnalisisScreen",
  components: { GestionAnalisis }
};
</script>